/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminUsersControllerGetAvailablePermissions$Params {
}

export function adminUsersControllerGetAvailablePermissions(http: HttpClient, rootUrl: string, params?: AdminUsersControllerGetAvailablePermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'permissions'?: Array<{
'value'?: string;
'label'?: string;
'category'?: string;
'description'?: string;
}>;
}>> {
  const rb = new RequestBuilder(rootUrl, adminUsersControllerGetAvailablePermissions.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'permissions'?: Array<{
      'value'?: string;
      'label'?: string;
      'category'?: string;
      'description'?: string;
      }>;
      }>;
    })
  );
}

adminUsersControllerGetAvailablePermissions.PATH = '/admin/users/permissions/available';
